const ua = window.navigator?.userAgent ?? "";

function searchMobil(ua) {
    const regex = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|mini/i
    return regex.test(ua)
}
function handleize(strText = '') {
    return strText ? strText.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') : ''
}
function leftPad(str = '', size = 0, complement = '') {
    str = str.toString();
    return str.padStart(size, complement);
}
function parseCouponDate(coupon_date = null, changeExpired = false) {
    //08.03.21
    coupon_date =  coupon_date && coupon_date!=='' ? (coupon_date.replace('-','/').replace('-','/')):'';
    const _date = coupon_date && coupon_date!=='' ? (new Date(coupon_date.includes(':')?coupon_date:(coupon_date+' 00:00:00'))) : '';
    const _day = leftPad(_date!==''?_date.getDate():0, 2, '0');
    const _month = leftPad(_date!==''?(_date.getMonth()+1):0, 2, '0');
    const _year = _date!==''?_date.getFullYear().toString().substr(-2):'00';
    let res = `${_day}.${_month}.${_year}`;

    if(changeExpired){
        let expired =  Date.parse(coupon_date+' 23:59');
        let expiredDate = new Date(expired);
        let now = new Date();
        if(`${expiredDate.getFullYear()}${expiredDate.getMonth()}${expiredDate.getDate()}`===`${now.getFullYear()}${now.getMonth()}${now.getDate()}`){
            res = 'hoy';
        }
    }
    return res;
}
const passwordValidation = {
    password: {
        keyup: {
            isHtml: true,
            rules: [
                {
                    showForce: true,
                    keyref: 'pattern',
                    value: /^.{8,}$/, 
                    message: `<li><span class="icon-checkmark">OK</span><span class="instruction">Mínimo de 8 caracteres</span></li>`
                }, 
                {
                    showForce: true,
                    keyref: 'pattern',
                    value: /\d{1,}/,
                    message: `<li><span class="icon-checkmark">OK</span><span class="instruction">1 número</span></li>`
                },
                {
                    showForce: true,
                    keyref: 'pattern',
                    value: /[a-z]{1,}/,
                    message: `<li><span class="icon-checkmark">OK</span><span class="instruction">1 letra minúscula</span></li>`
                }, 
                {
                    showForce: true,
                    keyref: 'pattern',
                    value: /[A-Z]{1,}/,
                    message: `<li><span class="icon-checkmark">OK</span><span class="instruction">1 letra mayúscula</span></li>`
                }
            ]
        },
        pattern: {
            value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\d])\S{8,}$/,
            message: "Ingrese una contraseña válida"
        }
    },
    password_confirm: {
        keyup: {
            reuse: 'match'
        },
        required: {
            value: true, 
            message: "Confirme su contraseña"
        }, 
        match: {
            value: 'password', 
            message: 'La contraseñas no son iguales'
        }
    }
}
export const ie = (ua.indexOf("MSIE ") !== -1) || (ua.indexOf("Trident/") !== -1);
export const mobile = window && window.hasOwnProperty ? (Object.prototype.hasOwnProperty.call(window, 'ontouchstart') && searchMobil(ua)) : false;
export const ieMobile = /iemobile/i.test(ua);
export const iphone = /iphone/i.test(ua) && !ieMobile;
export { handleize, leftPad, parseCouponDate, passwordValidation };